import { Component, OnInit } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'cv-custom-tooltip-cell-renderer',
  templateUrl: './custom-tooltip-cell-renderer.component.html',
  styleUrls: ['./custom-tooltip-cell-renderer.component.scss']
})
export class CustomTooltipCellRendererComponent implements OnInit {

  params: ICellRendererParams;
  cellData: string = "";
  tooltipArray: string[] = [];
  tooltipString: string = "";
  firstCellDisplayed: string;
  tooltipLength: number = 0;

  constructor() { }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    if(this.params.column.getColId() != "Users"){
      this.cellData = params.value;
      this.setUpDisplay();
    }
    else{
      this.setUpUsers();
    }
  }

  ngOnInit(): void {
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  private setUpDisplay(){
    if(this.cellData != "" && this.cellData != null){
      this.tooltipArray = this.cellData.split(',');

      this.firstCellDisplayed = this.tooltipArray[0];
      this.tooltipArray.shift();
      this.tooltipLength = this.tooltipArray.length;

      if(this.tooltipArray.length > 25){
        //here I need to cutoff the tooltip and only show the first 25
        let overflow = this.tooltipArray.length - 25;
        for(let i = 0; i < 25; i++){
          this.tooltipString += this.tooltipArray[i] + ", ";
        }
        this.tooltipString = this.tooltipString.slice(0, this.tooltipString.length - 1);
        this.tooltipString += ` +` + overflow.toString();
      }
      else{
        this.tooltipString = this.tooltipArray.join(", ");
      }
    }
  }

  private setUpUsers(){
    let array = this.params.data.LoginIDs;

    if(array.length > 0){
      let userList = this.params.context.getUserList();

      array.forEach(alert => {
        let user = userList.find((element) => element.LoginID == alert);
        this.cellData += user.LoginName + ",";
      });
      this.cellData = this.cellData.slice(0, this.cellData.length - 1);
      
      this.setUpDisplay();
    }
  }
}
